// Accessibility notes
//  With NVDA on, we must be able to loop through the menu
//  With NVDA off, we must be able to tab and shift+tab and loop through the menu
export default class mobileNav {

    constructor() {
        var enabledMobile = false;
        var $openBtn = $('.open-mobile-js');
        var $closeBtn = $('.close-mobile-nav-js');
        var $notMenu = $('body > div:first-child');
        var $menuContainer = $('.mobile-nav');
        var $navItemsWrapper = $menuContainer.find('.primary-mobile-nav-js');
        var $firstOption = $navItemsWrapper.children('li').first().children('.nav-button-js');
        var $lastOption = $navItemsWrapper.children('li').last().children('.nav-button-js');
        var $submenuBtn = $navItemsWrapper.find('.toggle-submenu-js');

        $(window).scroll(function () {
            let breakPoint = (window.innerWidth > 700) ? 300 : 30;

            if (window.scrollY >= breakPoint) {
                $('header').addClass('header-sticky');
            }

            if (window.scrollY < breakPoint && $('header').hasClass('header-sticky')) {
                $('header').removeClass('header-sticky');
            }
        });

        $openBtn.on('click keydown', function (e) {
            var pressed = e.which || e.keyCode;
            var eventType = e.type;

            if (eventType === 'click' || (eventType === 'keydown' && (pressed === 13 || pressed === 40))) {
                enabledMobile ? $.fn.closeMobileMenu() : $.fn.openMobileMenu()
            }

            // If (TAB or ARROW_DOWN or ENTER) && MOBILE_OPEN
            if ((pressed === 9 || pressed === 40 || pressed === 13) && enabledMobile) {
                e.preventDefault();
                $firstOption.focus();
            }
        });

        $closeBtn.on('click keydown', function (e) {
            e.stopImmediatePropagation();
            var pressed = e.which;

            if (e.type === 'click' // ENTER or SPACEBAR
                || (e.type === 'keydown' && (pressed === 13 || pressed === 32))
            ) {
                $.fn.closeMobileMenu();
            }

            // shift+tab or arrow up to navigate to the previous element
            if ((pressed === 9 && e.shiftKey) || pressed === 38) { // SHIFT + TAB or ARROW_UP
                e.preventDefault();
                $lastOption.focus();
            }

            if (pressed === 40) { // ARROW_DOWN
                $firstOption.focus();
            }
        });

        $lastOption.keydown(function (e) {
            var pressed = e.which;

            if (pressed === 9 || pressed === 40) {
                e.preventDefault();
                $closeBtn.focus();
            }

            if (pressed === 9 && e.shiftKey)
                $(this).parent().prev().children('.nav-button-js').focus();
        });

        // if esc key pressed while focus is anywhere inside the mobile nav
        $menuContainer.keydown(function (e) {
            (e.which === 27 && enabledMobile) && closeMobileMenu();
        });

        $('body').focusin(function (e) {
            if (enabledMobile && !$menuContainer.find($(e.target)).length) {
                enabledMobile = false;
                $.fn.closeMobileMenu();
            }
        });

        $('.mobile-menu-js').click(function (e) {
            if ($menuContainer[0].contains(e.target)) {
                return;
            }

            $.fn.closeMobileMenu();
        });

        // handles both submenu and nested submenu
        $submenuBtn.on('click keydown', function (e) {
            var type = e.type;
            var pressed = e.keyCode;
            var $this = $(this);
            var $container = $this.parent();
            var $submenu = $container.children('.mobile-submenu-js');
            var open = $container.hasClass('active');

            // ENTER or LEFT_ARROW or RIGHT_ARROW or SPACE
            if (type === 'click'
                || (type === 'keydown' && (pressed === 13 || pressed === 37 || pressed === 39 || pressed === 32))
            ) {
                // RIGHT_ARROW or ENTER or SPACE
                if (!open
                    || (type === 'keydown' && !open && (pressed === 39 || pressed === 13 || pressed === 32))
                ) {
                    $this.attr('aria-expanded', true).attr('aria-pressed', true);
                    $container.addClass('active');
                    $submenu.children('li').children('.nav-button-js').attr('tabindex', '0');
                    // fix me
                    $('.mobile-search-box-wrapper').addClass('submenu-open');
                    $(this).find('.icon-link').first().addClass('rotate-icon');
                } else if (open
                    || (type === 'keydown' && !open
                        && (pressed === 37 || pressed === 13 || pressed === 32))
                ) {
                    $this.attr('aria-expanded', false).attr('aria-pressed', false);
                    $container.removeClass('active');
                    $submenu.children('li').removeClass('active').children('.nav-button-js').attr('tabindex', '-1');
                    $(this).find('.icon-link').first().removeClass('rotate-icon');
                    $('.mobile-search-box-wrapper').removeClass('submenu-open');
                }
            }
        });

        // move mobile menu to the top level of the HTML to be sure it'll appear above all other elements
        $('.mobile-menu-js').appendTo('body');

        $.fn.openMobileMenu = function () {
            $('.animated-bucket-js').removeClass('animated'); // prevent chrome transition/animation delay bug

            $notMenu.attr('aria-hidden', 'true');
            $closeBtn.attr('aria-pressed', 'false').attr('tabindex', '0');
            $openBtn.attr('aria-pressed', 'true');
            $navItemsWrapper.attr('aria-hidden', 'false').find('input[tabindex="-1"]').attr('tabindex', '0');
            $navItemsWrapper.children('li').children('.nav-button-js').attr('tabindex', '0');

            $menuContainer.removeClass('hidden').addClass('expand');
            $menuContainer.parent().addClass('active').addClass('active fade-window');
            $('body').addClass('mobile-open');

            enabledMobile = true;
        }

        $.fn.closeMobileMenu = function () {
            $notMenu.attr('aria-hidden', 'false');
            $closeBtn.attr('aria-pressed', 'true').attr('tabindex', '-1');
            $navItemsWrapper.attr('aria-hidden', 'true').find('input[tabindex="-1"]').attr('tabindex', '-1');
            $openBtn.attr('aria-pressed', 'false');
            $navItemsWrapper.children('li').children('.nav-button-js').attr('tabindex', '-1');
            $menuContainer.removeClass('expand').parent().removeClass('fade-window');

            // close submenus -- 'active' class added by $('.toggle-submenu-js') function
            $('li.active').children('.toggle-submenu-js').click();

            $('.animated-bucket-js').addClass('animated'); // prevent chrome transition/animation delay bug

            setTimeout(function () {
                $('body').removeClass('mobile-open');
                $menuContainer.parent().removeClass('active');
                enabledMobile = false;
                $openBtn.focus();
            }, 750);
        }

    }
}
